<template>
  <div class="data-statistics">
    <!-- 标题区域 -->
    <div class="divHeader">
      <div class="header-title">📊 数据统计</div>
<!--      <div class="header-actions">-->
<!--        <el-button size="small" type="primary" icon="el-icon-refresh" @click="refreshData">刷新</el-button>-->
<!--        <el-button size="small" plain icon="el-icon-download" @click="exportReport">导出报告</el-button>-->
<!--      </div>-->
    </div>
    <div class="divider"></div>

    <!-- 统计卡片 -->
    <div class="stat-cards">
      <div class="stat-card" v-for="item in statCards" :key="item.key">
        <div class="stat-card-icon" :style="{ backgroundColor: item.bgColor }">
          <i :class="item.icon"></i>
        </div>
        <div class="stat-card-content">
          <div class="stat-card-title">{{ item.title }}</div>
          <div class="stat-card-value">{{ item.value }}</div>
          <div class="stat-card-desc">
<!--            <span class="trend" :class="item.trend > 0 ? 'trend-up' : 'trend-down'">-->
<!--              {{ item.trend > 0 ? '↑' : '↓' }} {{ Math.abs(item.trend) }}%-->
<!--            </span>-->
<!--            <span>较昨日</span>-->
          </div>
        </div>
      </div>
    </div>

    <!-- 图表区域（单图全宽） -->
    <div class="chart-container">
      <div class="chart-box">
        <div class="chart-header">
          <span class="chart-title">📈 最近一周人数增长趋势</span>
          <div class="chart-legend">
            <span><span class="legend-dot" style="background:#5B8BD4;"></span>公众号关注</span>
            <span><span class="legend-dot" style="background:#6FCF97;"></span>小程序使用</span>
          </div>
        </div>
        <div ref="userChartRef" class="chart"></div>
      </div>
    </div>

    <!-- 加载遮罩 -->
    <div v-if="loading" class="loading-mask">
      <i class="el-icon-loading"></i> 数据加载中...
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import * as echarts from 'echarts';

export default {
  name: 'ProDataPoint',
  data() {
    return {
      loading: false,
      statistics: {
        officialAccountUsers: 0,
        miniProgramUsers: 0,
        boundDevices: 0,
        onlineDevices: 0,
        offlineDevices: 0,
      },
      trends: {
        officialAccountUsers: 0,
        miniProgramUsers: 0,
        boundDevices: 0,
        onlineDevices: 0,
        offlineDevices: 0,
      },
      userTrendData: {
        dates: [],
        officialAccount: [],
        miniProgram: [],
      },
      deviceTrendData: {
        dates: [],
        total: [],
        online: [],
        offline: [],
      },
      userChart: null,
      deviceChart: null,
      fileName: '数据统计报告.xlsx',
    };
  },
  computed: {
    statCards() {
      const s = this.statistics;
      const t = this.trends;
      // 为每个卡片分配柔和的背景色（莫兰迪色系）
      const colors = [
        { bg: '#E8F0FE', icon: '#5B8BD4' },
        { bg: '#E6F7EC', icon: '#6FCF97' },
        { bg: '#FFF4E0', icon: '#E8A87C' },
        { bg: '#E9F5F9', icon: '#73A9C9' },
        { bg: '#FDECEC', icon: '#D48B8B' },
      ];
      const items = [
        {
          key: 'officialAccount',
          title: '公众号关注用户',
          value: this.formatNumber(s.officialAccountUsers),
          icon: 'el-icon-user',
          trend: t.officialAccountUsers,
        },
        {
          key: 'miniProgram',
          title: '小程序使用用户',
          value: this.formatNumber(s.miniProgramUsers),
          icon: 'el-icon-mobile',
          trend: t.miniProgramUsers,
        },
        {
          key: 'boundDevices',
          title: '绑定设备数量',
          value: this.formatNumber(s.boundDevices),
          icon: 'el-icon-link',
          trend: t.boundDevices,
        },
        {
          key: 'onlineDevices',
          title: '在线设备数量',
          value: this.formatNumber(s.onlineDevices),
          icon: 'el-icon-success',
          trend: t.onlineDevices,
        },
        {
          key: 'offlineDevices',
          title: '离线设备数量',
          value: this.formatNumber(s.offlineDevices),
          icon: 'el-icon-warning',
          trend: t.offlineDevices,
        },
      ];
      return items.map((item, index) => ({
        ...item,
        bgColor: colors[index % colors.length].bg,
        iconColor: colors[index % colors.length].icon,
      }));
    },
  },
  mounted() {
    this.fetchStatistics();
    this.$nextTick(() => {
      this.initCharts();
    });
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    if (this.userChart) {
      this.userChart.dispose();
      this.userChart = null;
    }
    if (this.deviceChart) {
      this.deviceChart.dispose();
      this.deviceChart = null;
    }
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    // ---------- 数据获取 ----------
    fetchStatistics() {
      this.loading = true;
      axios.get('http://106.52.65.234:8099/userListTwo')
          .then((res) => {
            const data = res.data;
            if (data && Array.isArray(data)) {
              // 绑定设备数 = data[4]
              const boundDevices = data[4] || 0;
              let onlineDevices = 0, offlineDevices = 0;
              // 从 data[5] 解析在线/离线设备
              if (data[5]) {
                try {
                  const deviceStr = data[5].replace(/\[|\]/g, '');
                  const parts = deviceStr.split(',').map(Number);
                  // parts[0] 是总设备（忽略），parts[1] 在线，parts[2] 离线
                  onlineDevices = parts[1] || 0;
                  offlineDevices = parts[2] || 0;
                } catch (e) {
                  console.warn('解析设备数据失败', e);
                }
              }

              this.statistics = {
                officialAccountUsers: data[0] || 0,
                miniProgramUsers: data[1] || 0,
                boundDevices: boundDevices,
                onlineDevices: onlineDevices,
                offlineDevices: offlineDevices,
              };

              const officialTrend = data[2] || [];
              const miniTrend = data[3] || [];
              this.trends = {
                officialAccountUsers: this.calcTrendPercent(officialTrend),
                miniProgramUsers: this.calcTrendPercent(miniTrend),
                boundDevices: 0,
                onlineDevices: 0,
                offlineDevices: 0,
              };

              const formatDate = (dateStr) => dateStr.slice(5);
              const officialDates = officialTrend.map((item) => formatDate(item.date));
              const officialValues = officialTrend.map((item) => item.cumulative);
              const miniDates = miniTrend.map((item) => formatDate(item.date));
              const miniValues = miniTrend.map((item) => item.cumulative);
              const dates = officialDates.length ? officialDates : miniDates;

              this.userTrendData = {
                dates: dates,
                officialAccount: officialValues,
                miniProgram: miniValues,
              };

              this.deviceTrendData = {
                dates: dates,
                total: [],
                online: [],
                offline: [],
              };

              this.loading = false;
              this.updateCharts();
            } else {
              this.$message.error('数据格式错误');
              this.loading = false;
            }
          })
          .catch((err) => {
            this.$notify({ title: '错误', message: err.message, type: 'warning' });
            this.loading = false;
          });
    },
    calcTrendPercent(trendArray) {
      if (!trendArray || trendArray.length < 2) return 0;
      const len = trendArray.length;
      const today = trendArray[len - 1].cumulative;
      const yesterday = trendArray[len - 2].cumulative;
      if (yesterday === 0) return 0;
      return parseFloat(((today - yesterday) / yesterday * 100).toFixed(1));
    },

    // ---------- 图表 ----------
    initCharts() {
      if (this.$refs.userChartRef) {
        this.userChart = echarts.init(this.$refs.userChartRef);
      }
      if (this.$refs.deviceChartRef) {
        this.deviceChart = echarts.init(this.$refs.deviceChartRef);
      }
      if (this.userTrendData.dates.length > 0) {
        this.updateCharts();
      }
    },

    updateCharts() {
      this.updateUserChart();
      this.updateDeviceChart();
    },

    updateUserChart() {
      if (!this.userChart) return;
      const { dates, officialAccount, miniProgram } = this.userTrendData;
      const option = {
        tooltip: { trigger: 'axis' },
        legend: { show: false },
        grid: { left: '3%', right: '4%', bottom: '3%', top: '8%', containLabel: true },
        xAxis: {
          type: 'category',
          data: dates,
          boundaryGap: false,
          axisLine: { lineStyle: { color: '#ddd' } },
          axisLabel: { color: '#999', fontWeight: 400 },
        },
        yAxis: {
          type: 'value',
          splitLine: { lineStyle: { color: '#f0f0f0', type: 'dashed' } },
          axisLabel: { color: '#999' },
        },
        series: [
          {
            name: '公众号关注',
            type: 'line',
            data: officialAccount,
            smooth: true,
            symbol: 'circle',
            symbolSize: 8,
            lineStyle: { width: 3, color: '#5B8BD4' },
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: 'rgba(91,139,212,0.25)' },
                { offset: 1, color: 'rgba(91,139,212,0.02)' },
              ]),
            },
            itemStyle: { color: '#5B8BD4' },
          },
          {
            name: '小程序使用',
            type: 'line',
            data: miniProgram,
            smooth: true,
            symbol: 'circle',
            symbolSize: 8,
            lineStyle: { width: 3, color: '#6FCF97' },
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: 'rgba(111,207,151,0.25)' },
                { offset: 1, color: 'rgba(111,207,151,0.02)' },
              ]),
            },
            itemStyle: { color: '#6FCF97' },
          },
        ],
      };
      this.userChart.setOption(option);
      this.userChart.resize();
    },

    updateDeviceChart() {
      if (!this.deviceChart) return;
      const { dates, total, online, offline } = this.deviceTrendData;
      if (total.length === 0) {
        this.deviceChart.clear();
        this.deviceChart.setOption({
          title: { text: '暂无设备趋势数据', left: 'center', top: 'center', textStyle: { color: '#bbb', fontSize: 14, fontWeight: 400 } },
        });
        return;
      }
      const option = {
        tooltip: { trigger: 'axis' },
        legend: { show: false },
        grid: { left: '3%', right: '4%', bottom: '3%', top: '8%', containLabel: true },
        xAxis: { type: 'category', data: dates, boundaryGap: false },
        yAxis: { type: 'value', splitLine: { lineStyle: { color: '#f0f0f0', type: 'dashed' } } },
        series: [
          {
            name: '总设备',
            type: 'line',
            data: total,
            smooth: true,
            symbol: 'circle',
            symbolSize: 8,
            lineStyle: { width: 3, color: '#5B8BD4' },
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: 'rgba(91,139,212,0.25)' },
                { offset: 1, color: 'rgba(91,139,212,0.02)' },
              ]),
            },
            itemStyle: { color: '#5B8BD4' },
          },
          {
            name: '在线设备',
            type: 'line',
            data: online,
            smooth: true,
            symbol: 'circle',
            symbolSize: 8,
            lineStyle: { width: 3, color: '#6FCF97' },
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: 'rgba(111,207,151,0.25)' },
                { offset: 1, color: 'rgba(111,207,151,0.02)' },
              ]),
            },
            itemStyle: { color: '#6FCF97' },
          },
          {
            name: '离线设备',
            type: 'line',
            data: offline,
            smooth: true,
            symbol: 'circle',
            symbolSize: 8,
            lineStyle: { width: 3, color: '#E8A87C' },
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: 'rgba(232,168,124,0.25)' },
                { offset: 1, color: 'rgba(232,168,124,0.02)' },
              ]),
            },
            itemStyle: { color: '#E8A87C' },
          },
        ],
      };
      this.deviceChart.setOption(option);
      this.deviceChart.resize();
    },

    handleResize() {
      if (this.userChart) this.userChart.resize();
      if (this.deviceChart) this.deviceChart.resize();
    },

    // ---------- 辅助 ----------
    formatNumber(num) {
      if (num === undefined || num === null) return '0';
      if (num >= 10000) return (num / 10000).toFixed(1) + '万';
      return num.toString();
    },

    // ---------- 操作 ----------
    refreshData() {
      this.fetchStatistics();
    },

    exportReport() {
      this.$message.info('导出功能开发中...');
    },
  },
};
</script>

<style scoped>
/* ====== 全局重置 ====== */
.data-statistics {
  padding: 24px 28px;
  background: #f2f4f8;
  min-height: 100vh;
  position: relative;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;
}

/* ====== 标题栏 ====== */
.divHeader {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #ffffff;
  padding: 0 24px;
  height: 64px;
  border-radius: 16px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.04);
  backdrop-filter: blur(2px);
}
.header-title {
  font-size: 20px;
  font-weight: 600;
  color: #1f2a3a;
  letter-spacing: 0.3px;
}
.header-actions {
  display: flex;
  gap: 12px;
}
.header-actions .el-button {
  border-radius: 20px;
  padding: 8px 18px;
  font-weight: 500;
  transition: all 0.25s;
}
.header-actions .el-button--primary {
  background: #5B8BD4;
  border-color: #5B8BD4;
  box-shadow: 0 2px 6px rgba(91, 139, 212, 0.25);
}
.header-actions .el-button--primary:hover {
  background: #4a7abf;
  border-color: #4a7abf;
  box-shadow: 0 4px 12px rgba(91, 139, 212, 0.35);
  transform: translateY(-1px);
}
.header-actions .el-button--plain {
  border-color: #d0d7de;
  color: #4a5568;
}
.header-actions .el-button--plain:hover {
  background: #f7fafc;
  border-color: #b0b8c4;
}
.divider {
  height: 1px;
  background: linear-gradient(to right, #e2e8f0, transparent);
  margin: 16px 0 24px 0;
}

/* ====== 统计卡片 ====== */
.stat-cards {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 18px;
  margin-bottom: 28px;
}
.stat-card {
  background: #ffffff;
  border-radius: 16px;
  padding: 20px 22px;
  display: flex;
  align-items: center;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  transition: all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  border: 1px solid rgba(255, 255, 255, 0.6);
  backdrop-filter: blur(2px);
}
.stat-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 12px 28px rgba(0, 0, 0, 0.07);
  border-color: #e9edf2;
}
.stat-card-icon {
  width: 52px;
  height: 52px;
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  margin-right: 16px;
  flex-shrink: 0;
  color: #2d3748;
  transition: transform 0.3s;
}
.stat-card:hover .stat-card-icon {
  transform: scale(1.02);
}
.stat-card-content {
  flex: 1;
  min-width: 0;
}
.stat-card-title {
  font-size: 14px;
  color: #7a889a;
  font-weight: 500;
  margin-bottom: 6px;
  letter-spacing: 0.2px;
}
.stat-card-value {
  font-size: 28px;
  font-weight: 700;
  color: #1a2533;
  line-height: 1.2;
  letter-spacing: -0.3px;
}
.stat-card-desc {
  font-size: 13px;
  color: #a0aec0;
  margin-top: 6px;
  display: flex;
  align-items: center;
  gap: 6px;
}
.trend {
  font-weight: 600;
  padding: 0 4px;
}
.trend-up {
  color: #6FCF97;
}
.trend-down {
  color: #E8A87C;
}

/* ====== 图表容器（单图全宽） ====== */
.chart-container {
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px;
  margin-top: 4px;
}
.chart-box {
  background: #ffffff;
  border-radius: 16px;
  padding: 20px 24px 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.6);
  transition: box-shadow 0.3s;
}
.chart-box:hover {
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.06);
}
.chart-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
  padding-bottom: 10px;
  border-bottom: 1px solid #f0f2f5;
}
.chart-title {
  font-size: 16px;
  font-weight: 600;
  color: #1f2a3a;
  letter-spacing: 0.2px;
}
.chart-legend {
  display: flex;
  gap: 20px;
  font-size: 13px;
  color: #4a5568;
  font-weight: 500;
}
.legend-dot {
  display: inline-block;
  width: 12px;
  height: 12px;
  border-radius: 4px;
  margin-right: 6px;
  vertical-align: middle;
}
.chart {
  width: 100%;
  height: 300px;
}

/* ====== 加载遮罩 ====== */
.loading-mask {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.7);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  color: #5B8BD4;
  border-radius: 20px;
  z-index: 10;
  gap: 12px;
  font-weight: 500;
}
.loading-mask i {
  font-size: 28px;
}

/* ====== 响应式 ====== */
@media screen and (max-width: 1200px) {
  .stat-cards {
    grid-template-columns: repeat(3, 1fr);
  }
}
@media screen and (max-width: 768px) {
  .data-statistics {
    padding: 16px;
  }
  .stat-cards {
    grid-template-columns: repeat(2, 1fr);
    gap: 12px;
  }
  .divHeader {
    flex-direction: column;
    height: auto;
    padding: 16px;
    gap: 12px;
    align-items: stretch;
    border-radius: 12px;
  }
  .header-actions {
    justify-content: flex-end;
  }
  .stat-card {
    padding: 16px;
  }
  .stat-card-value {
    font-size: 22px;
  }
  .chart {
    height: 220px;
  }
  .chart-box {
    padding: 16px;
  }
}
@media screen and (max-width: 480px) {
  .stat-cards {
    grid-template-columns: 1fr;
  }
  .stat-card-icon {
    width: 44px;
    height: 44px;
    font-size: 20px;
    margin-right: 12px;
  }
  .stat-card-value {
    font-size: 20px;
  }
  .chart-legend {
    flex-wrap: wrap;
    gap: 12px;
    font-size: 12px;
  }
  .header-title {
    font-size: 18px;
  }
}
</style>